import React, { useState, useEffect } from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box, Chip } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPIFunnelSet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localAcceptedFilterModel, setLocalAcceptedFilterModel] = useState();
    const [leadKpiPayload, setLeadKpiPayload] = useState();
    const [proposalKpiPayload, setProposalKpiPayload] = useState();
    const [acceptedKpiPayload, setAcceptedKpiPayload] = useState();
    const [leadGoalPayload, setLeadGoalPayload] = useState();
    const [proposalGoalPayload, setProposalGoalPayload] = useState();
    const [winGoalPayload, setWinGoalPayload] = useState();
    const { getComparableTimeframe } = useDates();

    useEffect(() => {
        if (!filterModel) return;
        const localAcceptedFilterModel = { items: [...filterModel.items, { field: "status", operator: "equals", value: "accepted" }] }
        setLocalAcceptedFilterModel(localAcceptedFilterModel);
        setLocalDrawable(true);
    }, [filterModel])

    const getRate = (numerator, denominator) => {
        if (!numerator || !denominator || denominator === 0) return null;
        return numerator / denominator;
    };

    const leadToProposalNow = getRate(proposalKpiPayload?.kpi, leadKpiPayload?.kpi);
    const leadToProposalPast = getRate(proposalKpiPayload?.compare, leadKpiPayload?.compare);
    const proposalToAcceptedNow = getRate(acceptedKpiPayload?.kpi, proposalKpiPayload?.kpi);
    const proposalToAcceptedPast = getRate(acceptedKpiPayload?.compare, proposalKpiPayload?.compare);

    const leadVsGoalNow = getRate(leadKpiPayload?.kpi, leadGoalPayload?.kpi);
    const leadVsGoalPast = getRate(leadKpiPayload?.compare, leadGoalPayload?.compare);
    const proposalVsGoalNow = getRate(proposalKpiPayload?.kpi, proposalGoalPayload?.kpi);
    const proposalVsGoalPast = getRate(proposalKpiPayload?.compare, proposalGoalPayload?.compare);
    const winVsGoalNow = getRate(acceptedKpiPayload?.kpi, winGoalPayload?.kpi);
    const winVsGoalPast = getRate(acceptedKpiPayload?.compare, winGoalPayload?.compare);

    return (localDrawable &&
        <>
            <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
                <KPI
                    title="Leads"
                    dataProviderName={'statisticsviews/item/count/opportunities/lead'}
                    filters={filterModel}
                    compareFilters={
                        {
                            ...getComparableTimeframe(filterModel, 'registered_at'),
                            timeline: {
                                collection: 'views_opportunities_lead',
                                field: 'registered_at',
                                granularity: 'month'
                            }
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-hightlight'
                    onItemsChange={setLeadKpiPayload}
                />
                <Box className="mtska-chart mtska-kpi-conversion">
                    <strong className="mtska-kpi-conversion-now">
                        {leadToProposalNow != null ? `${(leadToProposalNow * 100).toFixed(1)}%` : '—'}
                    </strong>
                    <span className="mtska-kpi-conversion-past">
                        ({leadToProposalPast != null ? `${(leadToProposalPast * 100).toFixed(1)}%` : '—'})
                    </span>
                </Box>
                <KPI
                    title="Proposte"
                    dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                    filters={filterModel}
                    compareFilters={
                        {
                            ...getComparableTimeframe(filterModel, 'registered_at'),
                            timeline: {
                                collection: 'views_opportunities_proposal',
                                field: 'registered_at',
                                granularity: 'month'
                            }
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-hightlight'
                    onItemsChange={setProposalKpiPayload}
                />
                <Box className="mtska-chart mtska-kpi-conversion">
                    <strong className="mtska-kpi-conversion-now">
                        {proposalToAcceptedNow != null ? `${(proposalToAcceptedNow * 100).toFixed(1)}%` : '—'}
                    </strong>
                    <span className="mtska-kpi-conversion-past">
                        ({proposalToAcceptedPast != null ? `${(proposalToAcceptedPast * 100).toFixed(1)}%` : '—'})
                    </span>
                </Box>
                <KPI
                    title="Accettate"
                    dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                    filters={localAcceptedFilterModel}
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                            timeline: {
                                collection: 'views_opportunities_proposal',
                                field: 'registered_at',
                                granularity: 'month'
                            }
                        }
                    }
                    comparePositiveCondition={'straight'}
                    className='mtska-chart-kpi-hightlight'
                    onItemsChange={setAcceptedKpiPayload}
                />
            </Box>
            <Box className="mtska-kpi-set" sx={{ marginBottom: '0px', gap: '80px' }}>
                <Box className="mtska-chart mtska-kpi-conversion top-down">
                    <strong className="mtska-kpi-conversion-now">{((leadVsGoalNow ?? 0) * 100).toFixed(1)}%</strong>
                    <span className="mtska-kpi-conversion-past">
                        ({((leadVsGoalPast ?? 0) * 100).toFixed(1)}%)
                    </span>
                </Box>
                <Box className="mtska-chart mtska-kpi-conversion top-down">
                    <strong className="mtska-kpi-conversion-now">{((proposalVsGoalNow ?? 0) * 100).toFixed(1)}%</strong>
                    <span className="mtska-kpi-conversion-past">
                        ({((proposalVsGoalPast ?? 0) * 100).toFixed(1)}%)
                    </span>
                </Box>
                <Box className="mtska-chart mtska-kpi-conversion top-down">
                    <strong className="mtska-kpi-conversion-now">{((winVsGoalNow ?? 0) * 100).toFixed(1)}%</strong>
                    <span className="mtska-kpi-conversion-past">
                        ({((winVsGoalPast ?? 0) * 100).toFixed(1)}%)
                    </span>
                </Box>
            </Box>
            <Box className="mtska-kpi-set" sx={{ marginBottom: '0px', gap: '80px' }}>
                <KPI
                    title="Obiettivo Lead"
                    dataProviderName={'statisticsviews/goal/lead'}
                    filters={filterModel}
                    compareFilters={
                        {
                            ...getComparableTimeframe(filterModel, 'registered_at'),
                            timeline: {
                                collection: 'views_opportunities_lead',
                                field: 'registered_at',
                                granularity: 'month'
                            }
                        }
                    }
                    comparePositiveCondition={'straight'}
                    onItemsChange={setLeadGoalPayload}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Obiettivo Proposte"
                    dataProviderName={'statisticsviews/goal/proposal'}
                    filters={filterModel}
                    compareFilters={
                        {
                            ...getComparableTimeframe(filterModel, 'registered_at'),
                            timeline: {
                                collection: 'views_opportunities_proposal',
                                field: 'registered_at',
                                granularity: 'month'
                            }
                        }
                    }
                    comparePositiveCondition={'straight'}
                    onItemsChange={setProposalGoalPayload}
                    className='mtska-chart-kpi-short'
                />
                <KPI
                    title="Obiettivo Accettate"
                    dataProviderName={'statisticsviews/goal/win'}
                    filters={localAcceptedFilterModel}
                    compareFilters={
                        {
                            ...getComparableTimeframe(localAcceptedFilterModel, 'registered_at'),
                            timeline: {
                                collection: 'views_opportunities_proposal',
                                field: 'registered_at',
                                granularity: 'month'
                            }
                        }
                    }
                    comparePositiveCondition={'straight'}
                    onItemsChange={setWinGoalPayload}
                    className='mtska-chart-kpi-short'
                />
            </Box>
        </>
    )
}

export default KPIFunnelSet;